<div class="year-controller">
  <div class="year-controller__header">
    <button
      *ngIf="showNavigations"
      (click)="prev()"
      class="year-controller__control"
      [innerHTML]="getPrevIcon()"
      aria-label="previous month"
    >
      Prev
    </button>
    <button
      class="year-controller__action"
      (click)="toggleList()">
      {{year}}
    </button>
    <button
      *ngIf="showNavigations"
      (click)="next()"
      class="year-controller__control"
      [innerHTML]="getNextIcon()"
      aria-label="next month"
    >
      Next
    </button>
  </div>
  <div class="year-controller__body">
    <ng-container *ngIf="showList">
      <int-scrolling-layer
        [itemContent]="action"
        [list]="years" [selectedPredicate]="predicate.bind(this)">
      </int-scrolling-layer>
    </ng-container>
    <ng-content></ng-content>
  </div>
</div>

<ng-template #action let-item>
  <button
    intCalendarActionCell
    [isSelected]="isSelected(item)"
    (click)="onSelectHandler(item)"
  >
    {{ item }}
  </button>
</ng-template>
